import api from '../api';

export const MONITORAMENTO_LOADING = 'MONITORAMENTO_LOADING';
export const MONITORAMENTO_LOGS_LOADED = 'MONITORAMENTO_LOGS_LOADED';
export const MONITORAMENTO_STATS_LOADED = 'MONITORAMENTO_STATS_LOADED';
export const MONITORAMENTO_DATES_LOADED = 'MONITORAMENTO_DATES_LOADED';
export const MONITORAMENTO_ERROR = 'MONITORAMENTO_ERROR';

export function getLogs(filters = {}) {
    return async (dispatch) => {
        dispatch({ type: MONITORAMENTO_LOADING });
        try {
            const params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key] !== null && filters[key] !== '' && filters[key] !== undefined) {
                    params.append(key, filters[key]);
                }
            });
            const response = await api.get('monitoramento?' + params.toString());
            dispatch({ type: MONITORAMENTO_LOGS_LOADED, payload: response.data });
        } catch (error) {
            dispatch({ type: MONITORAMENTO_ERROR, payload: error.message });
        }
    };
}

export function getStats(filters = {}) {
    return async (dispatch) => {
        try {
            const params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key] !== null && filters[key] !== '' && filters[key] !== undefined) {
                    params.append(key, filters[key]);
                }
            });
            const response = await api.get('monitoramento/stats?' + params.toString());
            dispatch({ type: MONITORAMENTO_STATS_LOADED, payload: response.data });
        } catch (error) {
            dispatch({ type: MONITORAMENTO_ERROR, payload: error.message });
        }
    };
}

export function getDates() {
    return async (dispatch) => {
        try {
            const response = await api.get('monitoramento/dates');
            dispatch({ type: MONITORAMENTO_DATES_LOADED, payload: response.data });
        } catch (error) {
            dispatch({ type: MONITORAMENTO_ERROR, payload: error.message });
        }
    };
}
